import { render, staticRenderFns } from "./WealthManagement.vue?vue&type=template&id=333b346c&scoped=true"
import script from "./WealthManagement.vue?vue&type=script&lang=js"
export * from "./WealthManagement.vue?vue&type=script&lang=js"
import style0 from "./WealthManagement.vue?vue&type=style&index=0&id=333b346c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333b346c",
  null
  
)

export default component.exports